import tw from "twin.macro"
import { WhatsNextSectionProps } from "./WhatsNextSectionProps"
import { useContext } from "react"
import { LanguageContext } from "../../../../contexts/Language"
import { Link } from "../../../atoms/Link"
import Icon from "../../../atoms/Icon"
import { css } from "@emotion/react"
import useTealiumEvent from "../../../../hooks/Tealium/useTealiumEvent"

const WhatsNextSection: React.FC<WhatsNextSectionProps> = ({
  links,
  backgroundColor,
}) => {
  const { _ } = useContext(LanguageContext)
  const { trackTealEvent } = useTealiumEvent()
  return (
    <div
      css={[
        tw``,
        backgroundColor && `background: ${`${backgroundColor?.hex}`};`,
      ]}
    >
      <div
        css={[
          tw`max-w-[1440px] px-10 py-32 mx-auto text-white flex flex-col gap-10`,
        ]}
      >
        <h2 css={[tw`text-4xl block leading-[104.6%] lg:(text-center)`]}>
          {_("What's Next?")}
        </h2>
        {links && (
          <ul
            css={tw`grid grid-cols-1 divide-y lg:(grid-cols-none grid-flow-col auto-cols-auto w-full min-h-20 divide-y-0 divide-x)`}
          >
            {links.map((link, index) => {
              const isInventoryLink =
                link?.internalLink?.slug?.current?.includes("inventory")
              const isOffersLink =
                link?.internalLink?.slug?.current?.includes("offers")
              return (
                <li
                  css={[
                    tw` lg:(text-center w-full flex items-center justify-center)`,
                  ]}
                >
                  <Link
                    className="group"
                    to={
                      link?.anchor
                        ? `#${link?.anchor}`
                        : link?.externalUrl ||
                          `/${link?.internalLink?.slug?.current}${link?.inventoryFilter == "affordability" ? `?isAffordable=true` : ""}`
                    }
                    target={link?.externalUrl ? "_blank" : "_self"}
                    analytics-id={`${isInventoryLink ? `inventory` : isOffersLink ? "offers" : `next`}:hero:`}
                    onClick={() => {
                      trackTealEvent({
                        tealium_event: isInventoryLink
                          ? "view_inventory_click"
                          : link?.anchor
                            ? "lander_anchor"
                            : "cta_click",
                        ...(link?.internalLink?.slug?.current && {
                          link_href: `/${link?.internalLink?.slug?.current}`,
                        }),
                        ...(link?.internalLink?.slug?.current && {
                          coupon_module_text: link?.displayText,
                        }),
                        ...(link?.externalUrl && {
                          coupon_module_text: link?.displayText,
                        }),
                        ...(link?.externalUrl && {
                          link_href: `${link?.externalUrl}`,
                        }),
                        ...(link?.anchor && {
                          anchor_button_text: link?.displayText,
                        }),
                      })
                    }}
                    css={[
                      tw`m-4 font-semibold text-2xl flex content-center items-center  mx-auto`,
                      tw`lg:(text-center justify-center)`,
                      tw`focus-visible:(outline-gray-50)`,
                      tw`hover:text-white`,
                      css`
                        &:after {
                          ${tw`absolute w-full rounded-full h-0.5 bottom-0 left-0 bg-white origin-bottom-left transition-transform ease-out duration-300`}
                          content: "";
                          transform: scaleX(0);
                        }
                        @media (min-width: 1024px) {
                          &:hover:after {
                            transform: scaleX(1);
                            ${tw`origin-bottom-left`}
                          }
                        }
                        &:focus-visible:after {
                          transform: scaleX(1);
                          ${tw`origin-bottom-left`}
                        }
                      `,
                    ]}
                  >
                    <div
                      css={[
                        tw`relative flex items-center gap-2 justify-between w-full`, // mobile: icon far right
                        tw`lg:(justify-center w-auto)`, // desktop: center everything
                      ]}
                    >
                      <span css={[tw`justify-start`]}>{link?.displayText}</span>
                      <Icon.Chevron
                        strokeWidth={"4"}
                        css={[tw`text-white justify-end h-4 mt-2`]}
                      />
                    </div>
                  </Link>
                </li>
              )
            })}
          </ul>
        )}
      </div>
    </div>
  )
}

export default WhatsNextSection
